import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getTenantMemberships, setSession, switchTenant } from '@darice/auth-client';
import { DEFAULT_RETURN_TO, resolveReturnTo } from '../lib/returnTo';

export default function TenantPicker() {
  const location = useLocation();
  const memberships = getTenantMemberships();
  const [error, setError] = useState<string | null>(null);

  async function pick(tenantId: string) {
    setError(null);
    try {
      const res = await switchTenant(tenantId);
      if (!res.success || !res.sessionJwt || res.expiresAt == null) {
        if (res.error === 'NOT_A_MEMBER') {
          setError('You are no longer a member of that workspace.');
        } else {
          setError(res.error ?? 'SWITCH_FAILED');
        }
        return;
      }
      setSession(res.sessionJwt, res.expiresAt);
      // Design §3.14 step 7: after the workspace is chosen the session cookie
      // carries the new activeTenantId, so hand the browser back to the
      // validated return_to target (or the portal home).
      const returnTo = resolveReturnTo(new URLSearchParams(location.search).get('return_to'));
      window.location.assign(returnTo ?? DEFAULT_RETURN_TO);
    } catch (e) {
      setError((e as Error).message);
    }
  }

  return (
    <main className="auth-shell">
      <section className="signin-panel" aria-labelledby="workspace-title">
        <div className="brand-lockup">
          <div className="brand-mark" aria-hidden="true">D</div>
          <div>
            <p className="eyebrow">Darice Strategies</p>
            <h1 id="workspace-title">Choose a workspace</h1>
          </div>
        </div>
        <ul className="workspace-list">
          {memberships.map((m, index) => (
          <li key={m.tenantId}>
            <button className="workspace-button" data-testid={`tenant-option-${index + 1}`} onClick={() => pick(m.tenantId)}>
              <span>Workspace {index + 1}</span>
              <small>{m.role}</small>
            </button>
          </li>
        ))}
        </ul>
        {error && <p className="auth-error" data-testid="tenant-error">{error}</p>}
      </section>
    </main>
  );
}
